module.exports = __webpack_public_path__ + "static/img/guide.26bcc11.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/guide.png
// module id = H3Vf
// module chunks = 0